// extracted by mini-css-extract-plugin
export default {"textAlignButton":"TextAlignButtons_textAlignButton__EglGi","icon":"TextAlignButtons_icon__8iGia"};